module.exports = __webpack_public_path__ + "static/media/waterOn_logo.2b2aa6a4.png";